import {
  CONNECTOR_LOGOS,
  CONNECTOR_NAME,
  DEFAULT_CONNECTOR_LOGO,
  DEPRECATED_CONNECTORS,
  CONNECTOR_WHITELISTED_DOMAINS,
} from 'src/constants/connectors';
import { getDomainNameByEmail } from 'src/constants/utils';
import { ConnectorApiResponse, ConnectorCardField } from 'src/types/connector';

export const addImagesInConnectorsResponse = (
  connectedConnectors: ConnectorApiResponse[],
): ConnectorCardField[] => {
  return connectedConnectors.map((connectedConnector) => {
    let imageUrl = '';
    let imageAltText = '';

    switch (connectedConnector.type) {
      case CONNECTOR_NAME.CONFLUENCE:
        imageUrl = CONNECTOR_LOGOS.CONFLUENCE.imageUrl;
        imageAltText = CONNECTOR_LOGOS.CONFLUENCE.imageAltText;
        break;
      case CONNECTOR_NAME.GOOGLE_CHAT:
        imageUrl = CONNECTOR_LOGOS.GOOGLE_CHAT.imageUrl;
        imageAltText = CONNECTOR_LOGOS.GOOGLE_CHAT.imageAltText;
        break;
      case CONNECTOR_NAME.ZAPIER:
        imageUrl = CONNECTOR_LOGOS.ZAPIER.imageUrl;
        imageAltText = CONNECTOR_LOGOS.ZAPIER.imageAltText;
        break;
      case CONNECTOR_NAME.NOTION:
        imageUrl = CONNECTOR_LOGOS.NOTION.imageUrl;
        imageAltText = CONNECTOR_LOGOS.NOTION.imageAltText;
        break;
      case CONNECTOR_NAME.EXPOSE_API:
        imageUrl = CONNECTOR_LOGOS.EXPOSE_API.imageUrl;
        imageAltText = CONNECTOR_LOGOS.EXPOSE_API.imageAltText;
        break;
      case CONNECTOR_NAME.JIRA:
        imageUrl = CONNECTOR_LOGOS.JIRA.imageUrl;
        imageAltText = CONNECTOR_LOGOS.JIRA.imageAltText;
        break;
      case CONNECTOR_NAME.ASANA:
        imageUrl = CONNECTOR_LOGOS.ASANA.imageUrl;
        imageAltText = CONNECTOR_LOGOS.ASANA.imageAltText;
        break;
      default:
        imageUrl = DEFAULT_CONNECTOR_LOGO.imageUrl;
        imageAltText = DEFAULT_CONNECTOR_LOGO.imageAltText;
    }

    return {
      ...connectedConnector,
      imageUrl,
      imageAltText,
    };
  });
};

export const findConnectorDetailsByType = (
  connectorType: CONNECTOR_NAME,
  connectedConnectorCards: ConnectorCardField[],
): ConnectorCardField | undefined => {
  // At the moment we are assuming a single Confluence connection for each Hana org account
  const currentConnectorData = connectedConnectorCards.find(
    (connector) => connector.type === connectorType,
  );

  return currentConnectorData;
};

export const isConnectorVisibleForUser = (
  connectorType: CONNECTOR_NAME,
  userEmail?: string,
): boolean => {
  if (DEPRECATED_CONNECTORS.includes(connectorType)) {
    return false;
  }

  const domainName = userEmail ? getDomainNameByEmail(userEmail) : null;
  const whitelist = CONNECTOR_WHITELISTED_DOMAINS[connectorType];

  if (whitelist.length === 0) {
    return true;
  }

  return domainName ? whitelist.includes(domainName) : false;
};
